import React, { Component } from 'react'
import { Link } from 'react-router-dom'

import firebase from '../firebase.js'

export class InfoPanelList extends Component {
    constructor() {
        super()
        this.state = {
            list: [],
        }
    }

    componentDidMount() {
        const itemsRef = firebase.database().ref('infoPanel')
        itemsRef.on('value', snapshot => {
            let items = snapshot.val()
            let newState = []
            for (let item in items) {
                newState.push({
                    id: item,
                    item: items[item],
                })
            }
            this.setState({
                list: newState,
            })
        })
    }

    render() {
        return (
            <div>
                <h1> Available Info Panels </h1>
                <ul>
                    {this.state.list.map(item => {
                        return (
                            <li key={item.id}>
                                <Link to={`${item.id}`}> {item.id} </Link>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/InfoPanelList.js